module.exports = __webpack_public_path__ + "img/shopNum5.64ad8f9c.png";